import { Injectable } from '@angular/core';
import {
  CanDeactivate,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { NewStoryComponent } from 'app/+stories/new/new.component';
import { Observable } from 'rxjs';

@Injectable()
export class CanDeactivateNewStory
  implements CanDeactivate<NewStoryComponent> {
  constructor() {}

  public canDeactivate(
    component: NewStoryComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return component.canDeactivate ? component.canDeactivate(nextState) : true;
  }
}
